import request from '@/plugins/axios'
import {getOne, getRawResult} from "@/util/dbHelper";

export function putGameInstance(game, contents){
  const query = `REPLACE INTO instance (\`key\`,contents)
  values
    ('game-${game.id}','${JSON.stringify(contents)}')
  `
  return request.post(`/dbManager?putTeamInstance`, {query}).then(getRawResult)
}
export function getGameInstance(game){
  const query = `SELECT contents FROM instance WHERE \`key\` = 'game-${game.id}'`
  return request.post(`/dbManager?getTeamInstance`+game.id, {query}).then(getOne)
}

export function deleteGameInstance(gameId){
  const query = `DELETE FROM instance WHERE \`key\` = 'game-${gameId}'`
  return request.post(`/dbManager?deleteGameInstance`+gameId, {query}).then(getRawResult)
}